import * as React from 'react';

export const FlexibleSpace = () => <div style={{ flex: '0 0 0', marginLeft: 'auto' }} />;
